module.exports = __webpack_public_path__ + "img/Frametrophy.c42f3b69.png";